import React from "react";
import Pricing from ".";
import { useProductStore } from "../../app/search-results/product-store/context";
import Loader from "../loader";
import { useI18next } from "gatsby-plugin-react-i18next";

interface ProductPriceProps {
  loaderText?: string;
}

const ProductPrice: React.FC<ProductPriceProps> = ({ loaderText }) => {
  const [productState] = useProductStore();
  const { t } = useI18next();
  const priceText = productState?.price
    ? { prefix: "", suffix: "" }
    : { prefix: t("STARTING_FROM_SHORT"), suffix: t("PER_PERSON_SHORT") };
  const price = productState?.price ?? productState?.estimatedPrice;
  return price && (price.defaultPrice || price?.promoPrice) ? (
    <Pricing {...price} {...priceText} isTotalPrice={productState?.price ? true : false} />
  ) : productState?.isUnavailable ? (
    <></>
  ) : (
    <Loader loaderText={loaderText} />
  );
};

export default ProductPrice;
